export interface Deliverable {
  name: string
  category?: string
  quantity: string
  hours: number
}

export interface PlanConfig {
  hourlyRate?: number
  deliverables?: Deliverable[]
  totalHours?: number
  suggestedValue?: number
  supportPricingMode?: 'FIXO_2000' | 'BASE_500_MAIS_1_FATURAMENTO'
  monthlyFixedValue?: number
  monthlyBaseValue?: number
  revenueSharePercent?: number
  catalogScope?: 'rocket'
}

export interface Plan {
  id: string
  name: string
  category?: string
  type?: 'RECORRENTE' | 'PACOTE_HORAS' | 'DEMANDAS_ESPECIFICAS'
  description?: string
  baseValue?: string
  config?: PlanConfig
}

export const PLAN_TYPE_LABELS: Record<
  string,
  { label: string; variant: 'success' | 'warning' | 'info' }
> = {
  RECORRENTE: { label: 'Recorrente', variant: 'success' },
  PACOTE_HORAS: { label: 'Horas', variant: 'warning' },
  DEMANDAS_ESPECIFICAS: { label: 'Demanda', variant: 'info' },
}
